import PropTypes from 'prop-types';
import React from 'react';

const ReactPropTypes = PropTypes;

class DropdownMenuList extends React.Component {
  static propTypes = {
    items: ReactPropTypes.any,
  };

  static defaultProps = {
    items: null,
  };

  render() {
    return (
      <div className="dropdownMenu-list">
        {this.props.items}
      </div>
    );
  }
}

module.exports = DropdownMenuList;
